const openCityList = [
  [
      "A",
      [
          {
              "cityCode":"152900",
              "cityName":"阿拉善盟",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734095206793219",
              "countyCode":null,
              "regionNamePinyin":"alashanmeng",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"210300",
              "cityName":"鞍山市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130734101787656194",
              "countyCode":null,
              "regionNamePinyin":"anshanshi",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"340800",
              "cityName":"安庆市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734027154210817",
              "countyCode":null,
              "regionNamePinyin":"anqingshi",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"410500",
              "cityName":"安阳市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130733981742481410",
              "countyCode":null,
              "regionNamePinyin":"anyangshi",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"513200",
              "cityName":"阿坝藏族羌族自治州",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734064890363905",
              "countyCode":null,
              "regionNamePinyin":"abacangzuqiangzuzizhizhou",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"520400",
              "cityName":"安顺市",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130734073849397250",
              "countyCode":null,
              "regionNamePinyin":"anshunshi",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"542500",
              "cityName":"阿里地区",
              "provinceCode":"540000",
              "provinceName":"西藏自治区",
              "id":"1130734094594424834",
              "countyCode":null,
              "regionNamePinyin":"alidiqu",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"610900",
              "cityName":"安康市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130733969084071937",
              "countyCode":null,
              "regionNamePinyin":"ankangshi",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"652900",
              "cityName":"阿克苏地区",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734092820234242",
              "countyCode":null,
              "regionNamePinyin":"akesudiqu",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"654300",
              "cityName":"阿勒泰地区",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130733991536181250",
              "countyCode":null,
              "regionNamePinyin":"aletaidiqu",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"659002",
              "cityName":"阿拉尔市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734022871826441",
              "countyCode":null,
              "regionNamePinyin":"alaershi",
              "regionNameInitial":"A"
          },
          {
              "cityCode":"820000",
              "cityName":"澳门特别行政区",
              "provinceCode":"820000",
              "provinceName":"澳门特别行政区",
              "id":"1130733988944101378",
              "countyCode":null,
              "regionNamePinyin":"aomentebiexingzhengqu",
              "regionNameInitial":"A"
          }
      ]
  ],
  [
      "B",
      [
          {
              "cityCode":"110000",
              "cityName":"北京市",
              "provinceCode":"110000",
              "provinceName":"北京市",
              "id":"1130734065938939906",
              "countyCode":null,
              "regionNamePinyin":"beijingshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"130600",
              "cityName":"保定市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734047060377602",
              "countyCode":null,
              "regionNamePinyin":"baodingshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"150200",
              "cityName":"包头市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734054509461505",
              "countyCode":null,
              "regionNamePinyin":"baotoushi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"150800",
              "cityName":"巴彦淖尔市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130733991313883138",
              "countyCode":null,
              "regionNamePinyin":"bayannaoershi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"210500",
              "cityName":"本溪市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130734071290871809",
              "countyCode":null,
              "regionNamePinyin":"benxishi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"220600",
              "cityName":"白山市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130734046389288962",
              "countyCode":null,
              "regionNamePinyin":"baishanshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"220800",
              "cityName":"白城市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130733990667960322",
              "countyCode":null,
              "regionNamePinyin":"baichengshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"340300",
              "cityName":"蚌埠市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734096918069249",
              "countyCode":null,
              "regionNamePinyin":"bengbushi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"341600",
              "cityName":"亳州市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734098444795905",
              "countyCode":null,
              "regionNamePinyin":"bozhoushi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"371600",
              "cityName":"滨州市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734055063109633",
              "countyCode":null,
              "regionNamePinyin":"binzhoushi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"450500",
              "cityName":"北海市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130733988491116545",
              "countyCode":null,
              "regionNamePinyin":"beihaishi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"451000",
              "cityName":"百色市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130733983680249858",
              "countyCode":null,
              "regionNamePinyin":"baiseshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"469025",
              "cityName":"白沙黎族自治县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974255648770",
              "countyCode":null,
              "regionNamePinyin":"baishalizuzizhixian",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"469029",
              "cityName":"保亭黎族苗族自治县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974893182978",
              "countyCode":null,
              "regionNamePinyin":"baotinglizumiaozuzizhixian",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"511900",
              "cityName":"巴中市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130733989443223554",
              "countyCode":null,
              "regionNamePinyin":"bazhongshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"520500",
              "cityName":"毕节市",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130734064093446146",
              "countyCode":null,
              "regionNamePinyin":"bijieshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"530500",
              "cityName":"保山市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734093453574146",
              "countyCode":null,
              "regionNamePinyin":"baoshanshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"610300",
              "cityName":"宝鸡市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130734074340130817",
              "countyCode":null,
              "regionNamePinyin":"baojishi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"620400",
              "cityName":"白银市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734098398658562",
              "countyCode":null,
              "regionNamePinyin":"baiyinshi",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"652700",
              "cityName":"博尔塔拉蒙古自治州",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130733965162397697",
              "countyCode":null,
              "regionNamePinyin":"boertalamengguzizhizhou",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"652800",
              "cityName":"巴音郭楞蒙古自治州",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734098025365505",
              "countyCode":null,
              "regionNamePinyin":"bayinguolengmengguzizhizhou",
              "regionNameInitial":"B"
          },
          {
              "cityCode":"659005",
              "cityName":"北屯市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734022871826437",
              "countyCode":null,
              "regionNamePinyin":"beitunshi",
              "regionNameInitial":"B"
          }
      ]
  ],
  [
      "C",
      [
          {
              "cityCode":"130800",
              "cityName":"承德市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734082011512833",
              "countyCode":null,
              "regionNamePinyin":"chengdeshi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"130900",
              "cityName":"沧州市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130733979553054721",
              "countyCode":null,
              "regionNamePinyin":"cangzhoushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"140400",
              "cityName":"长治市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130733964134793218",
              "countyCode":null,
              "regionNamePinyin":"changzhishi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"150400",
              "cityName":"赤峰市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734083894755330",
              "countyCode":null,
              "regionNamePinyin":"chifengshi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"211300",
              "cityName":"朝阳市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130733972494041089",
              "countyCode":null,
              "regionNamePinyin":"chaoyangshi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"220100",
              "cityName":"长春市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130734027787550722",
              "countyCode":null,
              "regionNamePinyin":"changchunshi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"320400",
              "cityName":"常州市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130733960536080385",
              "countyCode":null,
              "regionNamePinyin":"changzhoushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"341100",
              "cityName":"滁州市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130733999769600001",
              "countyCode":null,
              "regionNamePinyin":"chuzhoushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"341700",
              "cityName":"池州市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734055306379266",
              "countyCode":null,
              "regionNamePinyin":"chizhoushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"430100",
              "cityName":"长沙市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130733981906059265",
              "countyCode":null,
              "regionNamePinyin":"changshashi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"430700",
              "cityName":"常德市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130734037300232194",
              "countyCode":null,
              "regionNamePinyin":"changdeshi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"431000",
              "cityName":"郴州市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130734067679576066",
              "countyCode":null,
              "regionNamePinyin":"chenzhoushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"445100",
              "cityName":"潮州市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733989074124801",
              "countyCode":null,
              "regionNamePinyin":"chaozhoushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"451400",
              "cityName":"崇左市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734074948304898",
              "countyCode":null,
              "regionNamePinyin":"chongzuoshi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"469023",
              "cityName":"澄迈县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974373089282",
              "countyCode":null,
              "regionNamePinyin":"chengmaixian",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"469026",
              "cityName":"昌江黎族自治县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974175956994",
              "countyCode":null,
              "regionNamePinyin":"changjianglizuzizhixian",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"500000",
              "cityName":"重庆市",
              "provinceCode":"500000",
              "provinceName":"重庆市",
              "id":"1130734043931426818",
              "countyCode":null,
              "regionNamePinyin":"chongqingshi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"510100",
              "cityName":"成都市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734068984004610",
              "countyCode":null,
              "regionNamePinyin":"chengdushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"532300",
              "cityName":"楚雄彝族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734092442746881",
              "countyCode":null,
              "regionNamePinyin":"chuxiongyizuzizhizhou",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"540300",
              "cityName":"昌都市",
              "provinceCode":"540000",
              "provinceName":"西藏自治区",
              "id":"1130733996854558722",
              "countyCode":null,
              "regionNamePinyin":"changdushi",
              "regionNameInitial":"C"
          },
          {
              "cityCode":"652300",
              "cityName":"昌吉回族自治州",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734044984197121",
              "countyCode":null,
              "regionNamePinyin":"changjihuizuzizhizhou",
              "regionNameInitial":"C"
          }
      ]
  ],
  [
      "D",
      [
          {
              "cityCode":"140200",
              "cityName":"大同市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130733986037448706",
              "countyCode":null,
              "regionNamePinyin":"datongshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"210200",
              "cityName":"大连市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130734091339644929",
              "countyCode":null,
              "regionNamePinyin":"dalianshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"210600",
              "cityName":"丹东市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130733992777695233",
              "countyCode":null,
              "regionNamePinyin":"dandongshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"230600",
              "cityName":"大庆市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734077712351234",
              "countyCode":null,
              "regionNamePinyin":"daqingshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"232700",
              "cityName":"大兴安岭地区",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734067641827329",
              "countyCode":null,
              "regionNamePinyin":"daxinganlingdiqu",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"370500",
              "cityName":"东营市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130733992203075586",
              "countyCode":null,
              "regionNamePinyin":"dongyingshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"371400",
              "cityName":"德州市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734089758392322",
              "countyCode":null,
              "regionNamePinyin":"dezhoushi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"441900",
              "cityName":"东莞市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734062591885313",
              "countyCode":null,
              "regionNamePinyin":"dongguanshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"460400",
              "cityName":"儋州市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733997571784705",
              "countyCode":null,
              "regionNamePinyin":"danzhoushi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"469007",
              "cityName":"东方市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733975761403906",
              "countyCode":null,
              "regionNamePinyin":"dongfangshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"469021",
              "cityName":"定安县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974519889922",
              "countyCode":null,
              "regionNamePinyin":"dinganxian",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"510600",
              "cityName":"德阳市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130733984032571393",
              "countyCode":null,
              "regionNamePinyin":"deyangshi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"511700",
              "cityName":"达州市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734035454738434",
              "countyCode":null,
              "regionNamePinyin":"dazhoushi",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"532900",
              "cityName":"大理白族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733977061638145",
              "countyCode":null,
              "regionNamePinyin":"dalibaizuzizhizhou",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"533100",
              "cityName":"德宏傣族景颇族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733992496676866",
              "countyCode":null,
              "regionNamePinyin":"dehongdaizujingpozuzizhizhou",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"533400",
              "cityName":"迪庆藏族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733974763159553",
              "countyCode":null,
              "regionNamePinyin":"diqingcangzuzizhizhou",
              "regionNameInitial":"D"
          },
          {
              "cityCode":"621100",
              "cityName":"定西市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734058506633218",
              "countyCode":null,
              "regionNamePinyin":"dingxishi",
              "regionNameInitial":"D"
          }
      ]
  ],
  [
      "E",
      [
          {
              "cityCode":"150600",
              "cityName":"鄂尔多斯市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130733960104067074",
              "countyCode":null,
              "regionNamePinyin":"eerduosishi",
              "regionNameInitial":"E"
          },
          {
              "cityCode":"420700",
              "cityName":"鄂州市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733984707854337",
              "countyCode":null,
              "regionNamePinyin":"ezhoushi",
              "regionNameInitial":"E"
          },
          {
              "cityCode":"422800",
              "cityName":"恩施土家族苗族自治州",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734057562914817",
              "countyCode":null,
              "regionNamePinyin":"enshitujiazumiaozuzizhizhou",
              "regionNameInitial":"E"
          }
      ]
  ],
  [
      "F",
      [
          {
              "cityCode":"210400",
              "cityName":"抚顺市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130734057726492674",
              "countyCode":null,
              "regionNamePinyin":"fushunshi",
              "regionNameInitial":"F"
          },
          {
              "cityCode":"210900",
              "cityName":"阜新市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130733980349972482",
              "countyCode":null,
              "regionNamePinyin":"fuxinshi",
              "regionNameInitial":"F"
          },
          {
              "cityCode":"341200",
              "cityName":"阜阳市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734010590904321",
              "countyCode":null,
              "regionNamePinyin":"fuyangshi",
              "regionNameInitial":"F"
          },
          {
              "cityCode":"350100",
              "cityName":"福州市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130734041070911490",
              "countyCode":null,
              "regionNamePinyin":"fuzhoushi",
              "regionNameInitial":"F"
          },
          {
              "cityCode":"361000",
              "cityName":"抚州市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130733988063297538",
              "countyCode":null,
              "regionNamePinyin":"fuzhoushi",
              "regionNameInitial":"F"
          },
          {
              "cityCode":"440600",
              "cityName":"佛山市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734060951912449",
              "countyCode":null,
              "regionNamePinyin":"foshanshi",
              "regionNameInitial":"F"
          },
          {
              "cityCode":"450600",
              "cityName":"防城港市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734093587791873",
              "countyCode":null,
              "regionNamePinyin":"fangchenggangshi",
              "regionNameInitial":"F"
          }
      ]
  ],
  [
      "G",
      [
          {
              "cityCode":"360700",
              "cityName":"赣州市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130734080157630465",
              "countyCode":null,
              "regionNamePinyin":"ganzhoushi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"440100",
              "cityName":"广州市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734026353098753",
              "countyCode":null,
              "regionNamePinyin":"guangzhoushi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"450300",
              "cityName":"桂林市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734039720345601",
              "countyCode":null,
              "regionNamePinyin":"guilinshi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"450800",
              "cityName":"贵港市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734064215080961",
              "countyCode":null,
              "regionNamePinyin":"guigangshi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"510800",
              "cityName":"广元市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734104866275329",
              "countyCode":null,
              "regionNamePinyin":"guangyuanshi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"511600",
              "cityName":"广安市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734061400702977",
              "countyCode":null,
              "regionNamePinyin":"guanganshi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"513300",
              "cityName":"甘孜藏族自治州",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734057420308482",
              "countyCode":null,
              "regionNamePinyin":"ganzicangzuzizhizhou",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"520100",
              "cityName":"贵阳市",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130733973030912002",
              "countyCode":null,
              "regionNamePinyin":"guiyangshi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"623000",
              "cityName":"甘南藏族自治州",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734041024774146",
              "countyCode":null,
              "regionNamePinyin":"gannancangzuzizhizhou",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"632600",
              "cityName":"果洛藏族自治州",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130734066559696898",
              "countyCode":null,
              "regionNamePinyin":"guoluocangzuzizhizhou",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"640400",
              "cityName":"固原市",
              "provinceCode":"640000",
              "provinceName":"宁夏回族自治区",
              "id":"1130734026093051905",
              "countyCode":null,
              "regionNamePinyin":"guyuanshi",
              "regionNameInitial":"G"
          },
          {
              "cityCode":"710600",
              "cityName":"高雄市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734013124263938",
              "countyCode":null,
              "regionNamePinyin":"gaoxiongshi",
              "regionNameInitial":"G"
          }
      ]
  ],
  [
      "H",
      [
          {
              "cityCode":"130400",
              "cityName":"邯郸市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734074369490946",
              "countyCode":null,
              "regionNamePinyin":"handanshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"131100",
              "cityName":"衡水市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734105155682306",
              "countyCode":null,
              "regionNamePinyin":"hengshuishi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"150100",
              "cityName":"呼和浩特市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734070766583810",
              "countyCode":null,
              "regionNamePinyin":"huhehaoteshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"150700",
              "cityName":"呼伦贝尔市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734013916987394",
              "countyCode":null,
              "regionNamePinyin":"hulunbeiershi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"211400",
              "cityName":"葫芦岛市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130733984221315074",
              "countyCode":null,
              "regionNamePinyin":"huludaoshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"230100",
              "cityName":"哈尔滨市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734071957766146",
              "countyCode":null,
              "regionNamePinyin":"haerbinshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"230400",
              "cityName":"鹤岗市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130733962775838721",
              "countyCode":null,
              "regionNamePinyin":"hegangshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"231100",
              "cityName":"黑河市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734089619980290",
              "countyCode":null,
              "regionNamePinyin":"heiheshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"320800",
              "cityName":"淮安市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734054580764673",
              "countyCode":null,
              "regionNamePinyin":"huaianshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"330100",
              "cityName":"杭州市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130734105407340545",
              "countyCode":null,
              "regionNamePinyin":"hangzhoushi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"330500",
              "cityName":"湖州市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130734013451419650",
              "countyCode":null,
              "regionNamePinyin":"huzhoushi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"340100",
              "cityName":"合肥市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130733979347533825",
              "countyCode":null,
              "regionNamePinyin":"hefeishi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"340400",
              "cityName":"淮南市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734046921965569",
              "countyCode":null,
              "regionNamePinyin":"huainanshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"340600",
              "cityName":"淮北市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130733993566224385",
              "countyCode":null,
              "regionNamePinyin":"huaibeishi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"341000",
              "cityName":"黄山市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734077175480322",
              "countyCode":null,
              "regionNamePinyin":"huangshanshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"371700",
              "cityName":"菏泽市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734068069646338",
              "countyCode":null,
              "regionNamePinyin":"hezeshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"410600",
              "cityName":"鹤壁市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734079348129794",
              "countyCode":null,
              "regionNamePinyin":"hebishi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"420200",
              "cityName":"黄石市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734045827252225",
              "countyCode":null,
              "regionNamePinyin":"huangshishi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"421100",
              "cityName":"黄冈市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733959130988545",
              "countyCode":null,
              "regionNamePinyin":"huanggangshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"430400",
              "cityName":"衡阳市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130734055742586881",
              "countyCode":null,
              "regionNamePinyin":"hengyangshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"431200",
              "cityName":"怀化市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130734015460491266",
              "countyCode":null,
              "regionNamePinyin":"huaihuashi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"441300",
              "cityName":"惠州市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733993343926274",
              "countyCode":null,
              "regionNamePinyin":"huizhoushi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"441600",
              "cityName":"河源市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733986368798721",
              "countyCode":null,
              "regionNamePinyin":"heyuanshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"451100",
              "cityName":"贺州市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734081705328641",
              "countyCode":null,
              "regionNamePinyin":"hezhoushi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"451200",
              "cityName":"河池市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734102685237250",
              "countyCode":null,
              "regionNamePinyin":"hechishi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"460100",
              "cityName":"海口市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130734103184359426",
              "countyCode":null,
              "regionNamePinyin":"haikoushi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"532500",
              "cityName":"红河哈尼族彝族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734060540870658",
              "countyCode":null,
              "regionNamePinyin":"honghehanizuyizuzizhizhou",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"610700",
              "cityName":"汉中市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130733993020964865",
              "countyCode":null,
              "regionNamePinyin":"hanzhongshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"630200",
              "cityName":"海东市",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130734012742582274",
              "countyCode":null,
              "regionNamePinyin":"haidongshi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"632200",
              "cityName":"海北藏族自治州",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130733977149718529",
              "countyCode":null,
              "regionNamePinyin":"haibeicangzuzizhizhou",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"632300",
              "cityName":"黄南藏族自治州",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130734104413290498",
              "countyCode":null,
              "regionNamePinyin":"huangnancangzuzizhizhou",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"632500",
              "cityName":"海南藏族自治州",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130734078588960770",
              "countyCode":null,
              "regionNamePinyin":"hainancangzuzizhizhou",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"632800",
              "cityName":"海西蒙古族藏族自治州",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130734000566517762",
              "countyCode":null,
              "regionNamePinyin":"haiximengguzucangzuzizhizhou",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"650500",
              "cityName":"哈密市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734046993268738",
              "countyCode":null,
              "regionNamePinyin":"hamishi",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"653200",
              "cityName":"和田地区",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130733962931027970",
              "countyCode":null,
              "regionNamePinyin":"hetiandiqu",
              "regionNameInitial":"H"
          },
          {
              "cityCode":"719010",
              "cityName":"花莲县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734026629922817",
              "countyCode":null,
              "regionNamePinyin":"hualianxian",
              "regionNameInitial":"H"
          }
      ]
  ],
  [
      "J",
      [
          {
              "cityCode":"140500",
              "cityName":"晋城市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130734026655088642",
              "countyCode":null,
              "regionNamePinyin":"jinchengshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"140700",
              "cityName":"晋中市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130734066396119041",
              "countyCode":null,
              "regionNamePinyin":"jinzhongshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"210700",
              "cityName":"锦州市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130734014445469698",
              "countyCode":null,
              "regionNamePinyin":"jinzhoushi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"220200",
              "cityName":"吉林市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130733969197318145",
              "countyCode":null,
              "regionNamePinyin":"jilinshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"230300",
              "cityName":"鸡西市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734015074615298",
              "countyCode":null,
              "regionNamePinyin":"jixishi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"230800",
              "cityName":"佳木斯市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734106053263362",
              "countyCode":null,
              "regionNamePinyin":"jiamusishi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"330400",
              "cityName":"嘉兴市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130733991095779330",
              "countyCode":null,
              "regionNamePinyin":"jiaxingshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"330700",
              "cityName":"金华市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130733981776035841",
              "countyCode":null,
              "regionNamePinyin":"jinhuashi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"360200",
              "cityName":"景德镇市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130733995470438402",
              "countyCode":null,
              "regionNamePinyin":"jingdezhenshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"360400",
              "cityName":"九江市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130734026386653186",
              "countyCode":null,
              "regionNamePinyin":"jiujiangshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"360800",
              "cityName":"吉安市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130734097371054081",
              "countyCode":null,
              "regionNamePinyin":"jianshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"370100",
              "cityName":"济南市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734101540192258",
              "countyCode":null,
              "regionNamePinyin":"jinanshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"370800",
              "cityName":"济宁市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130733979175567361",
              "countyCode":null,
              "regionNamePinyin":"jiningshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"410800",
              "cityName":"焦作市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734055335739394",
              "countyCode":null,
              "regionNamePinyin":"jiaozuoshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"419001",
              "cityName":"济源市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734078668652545",
              "countyCode":null,
              "regionNamePinyin":"jiyuanshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"420800",
              "cityName":"荆门市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734090429480961",
              "countyCode":null,
              "regionNamePinyin":"jingmenshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"421000",
              "cityName":"荆州市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734011207467010",
              "countyCode":null,
              "regionNamePinyin":"jingzhoushi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"440700",
              "cityName":"江门市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734076105932801",
              "countyCode":null,
              "regionNamePinyin":"jiangmenshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"445200",
              "cityName":"揭阳市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733979624357889",
              "countyCode":null,
              "regionNamePinyin":"jieyangshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"620200",
              "cityName":"嘉峪关市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130733973999796225",
              "countyCode":null,
              "regionNamePinyin":"jiayuguanshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"620300",
              "cityName":"金昌市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130733963396595714",
              "countyCode":null,
              "regionNamePinyin":"jinchangshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"620900",
              "cityName":"酒泉市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130733990932201473",
              "countyCode":null,
              "regionNamePinyin":"jiuquanshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"710700",
              "cityName":"基隆市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734045500096513",
              "countyCode":null,
              "regionNamePinyin":"jilongshi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"710900",
              "cityName":"嘉义市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734075279654914",
              "countyCode":null,
              "regionNamePinyin":"jiayishi",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"719006",
              "cityName":"嘉义县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022590808066",
              "countyCode":null,
              "regionNamePinyin":"jiayixian",
              "regionNameInitial":"J"
          },
          {
              "cityCode":"719012",
              "cityName":"金门县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734026516676610",
              "countyCode":null,
              "regionNamePinyin":"jinmenxian",
              "regionNameInitial":"J"
          }
      ]
  ],
  [
      "K",
      [
          {
              "cityCode":"410200",
              "cityName":"开封市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130733991951417346",
              "countyCode":null,
              "regionNamePinyin":"kaifengshi",
              "regionNameInitial":"K"
          },
          {
              "cityCode":"530100",
              "cityName":"昆明市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733994417668098",
              "countyCode":null,
              "regionNamePinyin":"kunmingshi",
              "regionNameInitial":"K"
          },
          {
              "cityCode":"650200",
              "cityName":"克拉玛依市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734100944601089",
              "countyCode":null,
              "regionNamePinyin":"kelamayishi",
              "regionNameInitial":"K"
          },
          {
              "cityCode":"653000",
              "cityName":"克孜勒苏柯尔克孜自治州",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130733988390453250",
              "countyCode":null,
              "regionNamePinyin":"kezilesukeerkezizizhizhou",
              "regionNameInitial":"K"
          },
          {
              "cityCode":"653100",
              "cityName":"喀什地区",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130733976071782401",
              "countyCode":null,
              "regionNamePinyin":"kashendiqu",
              "regionNameInitial":"K"
          },
          {
              "cityCode":"659008",
              "cityName":"可克达拉市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734023454834690",
              "countyCode":null,
              "regionNamePinyin":"kekedalashi",
              "regionNameInitial":"K"
          },
          {
              "cityCode":"659009",
              "cityName":"昆玉市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734023274479617",
              "countyCode":null,
              "regionNamePinyin":"kunyushi",
              "regionNameInitial":"K"
          }
      ]
  ],
  [
      "L",
      [
          {
              "cityCode":"131000",
              "cityName":"廊坊市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734062512193537",
              "countyCode":null,
              "regionNamePinyin":"langfangshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"141000",
              "cityName":"临汾市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130733997940883458",
              "countyCode":null,
              "regionNamePinyin":"linfenshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"141100",
              "cityName":"吕梁市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130734073706790914",
              "countyCode":null,
              "regionNamePinyin":"lvliangshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"211000",
              "cityName":"辽阳市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130734075317403649",
              "countyCode":null,
              "regionNamePinyin":"liaoyangshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"220400",
              "cityName":"辽源市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130734080837107713",
              "countyCode":null,
              "regionNamePinyin":"liaoyuanshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"320700",
              "cityName":"连云港市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734097152950274",
              "countyCode":null,
              "regionNamePinyin":"lianyungangshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"331100",
              "cityName":"丽水市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130733976981946370",
              "countyCode":null,
              "regionNamePinyin":"lishuishi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"341500",
              "cityName":"六安市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734078828036097",
              "countyCode":null,
              "regionNamePinyin":"luanshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"350800",
              "cityName":"龙岩市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130734068904312833",
              "countyCode":null,
              "regionNamePinyin":"longyanshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"371200",
              "cityName":"莱芜市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130733984808517633",
              "countyCode":null,
              "regionNamePinyin":"laiwushi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"371300",
              "cityName":"临沂市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734090563698689",
              "countyCode":null,
              "regionNamePinyin":"linyishi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"371500",
              "cityName":"聊城市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734099560480769",
              "countyCode":null,
              "regionNamePinyin":"liaochengshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"410300",
              "cityName":"洛阳市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734013220732929",
              "countyCode":null,
              "regionNamePinyin":"luoyangshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"411100",
              "cityName":"漯河市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734104757223425",
              "countyCode":null,
              "regionNamePinyin":"luoheshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"431300",
              "cityName":"娄底市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130733963325292545",
              "countyCode":null,
              "regionNamePinyin":"loudishi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"450200",
              "cityName":"柳州市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130733994996482049",
              "countyCode":null,
              "regionNamePinyin":"liuzhoushi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"451300",
              "cityName":"来宾市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734058376609793",
              "countyCode":null,
              "regionNamePinyin":"laibinshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"469024",
              "cityName":"临高县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974280814594",
              "countyCode":null,
              "regionNamePinyin":"lingaoxian",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"469027",
              "cityName":"乐东黎族自治县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974154985474",
              "countyCode":null,
              "regionNamePinyin":"ledonglizuzizhixian",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"469028",
              "cityName":"陵水黎族自治县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974125625346",
              "countyCode":null,
              "regionNamePinyin":"lingshuilizuzizhixian",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"510500",
              "cityName":"泸州市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130733995105533954",
              "countyCode":null,
              "regionNamePinyin":"luzhoushi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"511100",
              "cityName":"乐山市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130733966215168004",
              "countyCode":null,
              "regionNamePinyin":"leshanshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"513400",
              "cityName":"凉山彝族自治州",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734016353878018",
              "countyCode":null,
              "regionNamePinyin":"liangshanyizuzizhizhou",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"520200",
              "cityName":"六盘水市",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130734103649927169",
              "countyCode":null,
              "regionNamePinyin":"liupanshuishi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"530700",
              "cityName":"丽江市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734046120853506",
              "countyCode":null,
              "regionNamePinyin":"lijiangshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"530900",
              "cityName":"临沧市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733990009454593",
              "countyCode":null,
              "regionNamePinyin":"lincangshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"540100",
              "cityName":"拉萨市",
              "provinceCode":"540000",
              "provinceName":"西藏自治区",
              "id":"1130734063657238529",
              "countyCode":null,
              "regionNamePinyin":"lasashi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"540400",
              "cityName":"林芝市",
              "provinceCode":"540000",
              "provinceName":"西藏自治区",
              "id":"1130733987971022850",
              "countyCode":null,
              "regionNamePinyin":"linzhishi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"620100",
              "cityName":"兰州市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130733985278279681",
              "countyCode":null,
              "regionNamePinyin":"lanzhoushi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"621200",
              "cityName":"陇南市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734028999704578",
              "countyCode":null,
              "regionNamePinyin":"longnanshi",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"622900",
              "cityName":"临夏回族自治州",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130733967825780738",
              "countyCode":null,
              "regionNamePinyin":"linxiahuizuzizhizhou",
              "regionNameInitial":"L"
          },
          {
              "cityCode":"719013",
              "cityName":"连江县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734026478927873",
              "countyCode":null,
              "regionNamePinyin":"lianjiangxian",
              "regionNameInitial":"L"
          }
      ]
  ],
  [
      "M",
      [
          {
              "cityCode":"231000",
              "cityName":"牡丹江市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130733984003211266",
              "countyCode":null,
              "regionNamePinyin":"mudanjiangshi",
              "regionNameInitial":"M"
          },
          {
              "cityCode":"340500",
              "cityName":"马鞍山市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734068853981185",
              "countyCode":null,
              "regionNamePinyin":"maanshanshi",
              "regionNameInitial":"M"
          },
          {
              "cityCode":"440900",
              "cityName":"茂名市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734042798964738",
              "countyCode":null,
              "regionNamePinyin":"maomingshi",
              "regionNameInitial":"M"
          },
          {
              "cityCode":"441400",
              "cityName":"梅州市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734028819349506",
              "countyCode":null,
              "regionNamePinyin":"meizhoushi",
              "regionNameInitial":"M"
          },
          {
              "cityCode":"510700",
              "cityName":"绵阳市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130733978215071745",
              "countyCode":null,
              "regionNamePinyin":"mianyangshi",
              "regionNameInitial":"M"
          },
          {
              "cityCode":"511400",
              "cityName":"眉山市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734092413386753",
              "countyCode":null,
              "regionNamePinyin":"meishanshi",
              "regionNameInitial":"M"
          },
          {
              "cityCode":"719003",
              "cityName":"苗栗县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022590808070",
              "countyCode":null,
              "regionNamePinyin":"miaolixian",
              "regionNameInitial":"M"
          }
      ]
  ],
  [
      "N",
      [
          {
              "cityCode":"320100",
              "cityName":"南京市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734076592472066",
              "countyCode":null,
              "regionNamePinyin":"nanjingshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"320600",
              "cityName":"南通市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734078391828482",
              "countyCode":null,
              "regionNamePinyin":"nantongshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"330200",
              "cityName":"宁波市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130734043621048322",
              "countyCode":null,
              "regionNamePinyin":"ningboshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"350700",
              "cityName":"南平市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130734055704838146",
              "countyCode":null,
              "regionNamePinyin":"nanpingshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"350900",
              "cityName":"宁德市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130733992253407234",
              "countyCode":null,
              "regionNamePinyin":"ningdeshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"360100",
              "cityName":"南昌市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130734074646315009",
              "countyCode":null,
              "regionNamePinyin":"nanchangshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"411300",
              "cityName":"南阳市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734043755266049",
              "countyCode":null,
              "regionNamePinyin":"nanyangshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"450100",
              "cityName":"南宁市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734074293993474",
              "countyCode":null,
              "regionNamePinyin":"nanningshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"511000",
              "cityName":"内江市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130733983596363778",
              "countyCode":null,
              "regionNamePinyin":"neijiangshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"511300",
              "cityName":"南充市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734079155191810",
              "countyCode":null,
              "regionNamePinyin":"nanchongshi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"533300",
              "cityName":"怒江傈僳族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733985940979713",
              "countyCode":null,
              "regionNamePinyin":"nujianglisuzuzizhizhou",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"540600",
              "cityName":"那曲市",
              "provinceCode":"540000",
              "provinceName":"西藏自治区",
              "id":"1130734096628662274",
              "countyCode":null,
              "regionNamePinyin":"naqushi",
              "regionNameInitial":"N"
          },
          {
              "cityCode":"719005",
              "cityName":"南投县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022590808067",
              "countyCode":null,
              "regionNamePinyin":"nantouxian",
              "regionNameInitial":"N"
          }
      ]
  ],
  [
      "P",
      [
          {
              "cityCode":"211100",
              "cityName":"盘锦市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130733995973754882",
              "countyCode":null,
              "regionNamePinyin":"panjinshi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"350300",
              "cityName":"莆田市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130733985974534146",
              "countyCode":null,
              "regionNamePinyin":"putianshi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"360300",
              "cityName":"萍乡市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130734028345393154",
              "countyCode":null,
              "regionNamePinyin":"pingxiangshi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"410400",
              "cityName":"平顶山市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130733961756622851",
              "countyCode":null,
              "regionNamePinyin":"pingdingshanshi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"410900",
              "cityName":"濮阳市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734073497075714",
              "countyCode":null,
              "regionNamePinyin":"puyangshi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"510400",
              "cityName":"攀枝花市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734036020969474",
              "countyCode":null,
              "regionNamePinyin":"panzhihuashi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"530800",
              "cityName":"普洱市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734013841489921",
              "countyCode":null,
              "regionNamePinyin":"puershi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"620800",
              "cityName":"平凉市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734010704150529",
              "countyCode":null,
              "regionNamePinyin":"pingliangshi",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"719008",
              "cityName":"屏东县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022871826435",
              "countyCode":null,
              "regionNamePinyin":"pingdongxian",
              "regionNameInitial":"P"
          },
          {
              "cityCode":"719011",
              "cityName":"澎湖县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734026617339905",
              "countyCode":null,
              "regionNamePinyin":"penghuxian",
              "regionNameInitial":"P"
          }
      ]
  ],
  [
      "Q",
      [
          {
              "cityCode":"130300",
              "cityName":"秦皇岛市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130733996158304258",
              "countyCode":null,
              "regionNamePinyin":"qinhuangdaoshi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"230200",
              "cityName":"齐齐哈尔市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130733993121628161",
              "countyCode":null,
              "regionNamePinyin":"qiqihaershi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"230900",
              "cityName":"七台河市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734064345104386",
              "countyCode":null,
              "regionNamePinyin":"qitaiheshi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"330800",
              "cityName":"衢州市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130734081369784321",
              "countyCode":null,
              "regionNamePinyin":"quzhoushi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"350500",
              "cityName":"泉州市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130734102353887234",
              "countyCode":null,
              "regionNamePinyin":"quanzhoushi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"370200",
              "cityName":"青岛市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734099749224449",
              "countyCode":null,
              "regionNamePinyin":"qingdaoshi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"429005",
              "cityName":"潜江市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733964298371075",
              "countyCode":null,
              "regionNamePinyin":"qianjiangshi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"441800",
              "cityName":"清远市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734104547508226",
              "countyCode":null,
              "regionNamePinyin":"qingyuanshi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"450700",
              "cityName":"钦州市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734105910657025",
              "countyCode":null,
              "regionNamePinyin":"qinzhoushi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"469002",
              "cityName":"琼海市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733975316807683",
              "countyCode":null,
              "regionNamePinyin":"qionghaishi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"469030",
              "cityName":"琼中黎族苗族自治县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733975081926658",
              "countyCode":null,
              "regionNamePinyin":"qiongzhonglizumiaozuzizhixian",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"522300",
              "cityName":"黔西南布依族苗族自治州",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130734015682789377",
              "countyCode":null,
              "regionNamePinyin":"qianxinanbuyizumiaozuzizhizhou",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"522600",
              "cityName":"黔东南苗族侗族自治州",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130733984112263169",
              "countyCode":null,
              "regionNamePinyin":"qiandongnanmiaozudongzuzizhizhou",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"522700",
              "cityName":"黔南布依族苗族自治州",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130733972091387906",
              "countyCode":null,
              "regionNamePinyin":"qiannanbuyizumiaozuzizhizhou",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"530300",
              "cityName":"曲靖市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733977728532481",
              "countyCode":null,
              "regionNamePinyin":"qujingshi",
              "regionNameInitial":"Q"
          },
          {
              "cityCode":"621000",
              "cityName":"庆阳市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734077263560705",
              "countyCode":null,
              "regionNamePinyin":"qingyangshi",
              "regionNameInitial":"Q"
          }
      ]
  ],
  [
      "R",
      [
          {
              "cityCode":"371100",
              "cityName":"日照市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130733973165129729",
              "countyCode":null,
              "regionNamePinyin":"rizhaoshi",
              "regionNameInitial":"R"
          },
          {
              "cityCode":"540200",
              "cityName":"日喀则市",
              "provinceCode":"540000",
              "provinceName":"西藏自治区",
              "id":"1130734042618609666",
              "countyCode":null,
              "regionNamePinyin":"rikazeshi",
              "regionNameInitial":"R"
          }
      ]
  ],
  [
      "S",
      [
          {
              "cityCode":"130100",
              "cityName":"石家庄市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130733971856506881",
              "countyCode":null,
              "regionNamePinyin":"shijiazhuangshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"140600",
              "cityName":"朔州市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130733993771745282",
              "countyCode":null,
              "regionNamePinyin":"shuozhoushi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"210100",
              "cityName":"沈阳市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130733985588658177",
              "countyCode":null,
              "regionNamePinyin":"shenyangshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"220300",
              "cityName":"四平市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130733982963023873",
              "countyCode":null,
              "regionNamePinyin":"sipingshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"220700",
              "cityName":"松原市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130734066920407042",
              "countyCode":null,
              "regionNamePinyin":"songyuanshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"230500",
              "cityName":"双鸭山市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130733980605825025",
              "countyCode":null,
              "regionNamePinyin":"shuangyashanshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"231200",
              "cityName":"绥化市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734099338182657",
              "countyCode":null,
              "regionNamePinyin":"suihuashi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"310000",
              "cityName":"上海市",
              "provinceCode":"310000",
              "provinceName":"上海市",
              "id":"1130733995780816897",
              "countyCode":null,
              "regionNamePinyin":"shanghaishi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"320500",
              "cityName":"苏州市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130733980056371202",
              "countyCode":null,
              "regionNamePinyin":"suzhoushi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"321300",
              "cityName":"宿迁市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734063309111297",
              "countyCode":null,
              "regionNamePinyin":"suqianshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"330600",
              "cityName":"绍兴市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130733963576950785",
              "countyCode":null,
              "regionNamePinyin":"shaoxingshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"341300",
              "cityName":"宿州市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130733961303638018",
              "countyCode":null,
              "regionNamePinyin":"suzhoushi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"350400",
              "cityName":"三明市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130734091691966465",
              "countyCode":null,
              "regionNamePinyin":"sanmingshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"361100",
              "cityName":"上饶市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130734093248053250",
              "countyCode":null,
              "regionNamePinyin":"shangraoshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"411200",
              "cityName":"三门峡市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734095810772993",
              "countyCode":null,
              "regionNamePinyin":"sanmenxiashi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"411400",
              "cityName":"商丘市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734067465666561",
              "countyCode":null,
              "regionNamePinyin":"shangqiushi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"420300",
              "cityName":"十堰市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734068631683074",
              "countyCode":null,
              "regionNamePinyin":"shiyanshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"421300",
              "cityName":"随州市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734078337302529",
              "countyCode":null,
              "regionNamePinyin":"suizhoushi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"429021",
              "cityName":"神农架林区",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733961756622850",
              "countyCode":null,
              "regionNamePinyin":"shennongjialinqu",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"430500",
              "cityName":"邵阳市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130734073778094082",
              "countyCode":null,
              "regionNamePinyin":"shaoyangshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"440200",
              "cityName":"韶关市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733967444099076",
              "countyCode":null,
              "regionNamePinyin":"shaoguanshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"440300",
              "cityName":"深圳市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733985072758785",
              "countyCode":null,
              "regionNamePinyin":"shenzhenshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"440500",
              "cityName":"汕头市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734103838670849",
              "countyCode":null,
              "regionNamePinyin":"shantoushi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"441500",
              "cityName":"汕尾市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733969885184002",
              "countyCode":null,
              "regionNamePinyin":"shanweishi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"460200",
              "cityName":"三亚市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130734061958545410",
              "countyCode":null,
              "regionNamePinyin":"sanyashi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"460300",
              "cityName":"三沙市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130734075485175809",
              "countyCode":null,
              "regionNamePinyin":"sanshashi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"510900",
              "cityName":"遂宁市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734093944307714",
              "countyCode":null,
              "regionNamePinyin":"suiningshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"540500",
              "cityName":"山南市",
              "provinceCode":"540000",
              "provinceName":"西藏自治区",
              "id":"1130733961643376641",
              "countyCode":null,
              "regionNamePinyin":"shannanshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"611000",
              "cityName":"商洛市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130734041771360257",
              "countyCode":null,
              "regionNamePinyin":"shangluoshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"640200",
              "cityName":"石嘴山市",
              "provinceCode":"640000",
              "provinceName":"宁夏回族自治区",
              "id":"1130734066173820930",
              "countyCode":null,
              "regionNamePinyin":"shizuishanshi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"659001",
              "cityName":"石河子市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734024004288513",
              "countyCode":null,
              "regionNamePinyin":"shihezishi",
              "regionNameInitial":"S"
          },
          {
              "cityCode":"659007",
              "cityName":"双河市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734023706492929",
              "countyCode":null,
              "regionNamePinyin":"shuangheshi",
              "regionNameInitial":"S"
          }
      ]
  ],
  [
      "T",
      [
          {
              "cityCode":"120000",
              "cityName":"天津市",
              "provinceCode":"120000",
              "provinceName":"天津市",
              "id":"1130734042702495745",
              "countyCode":null,
              "regionNamePinyin":"tianjinshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"130200",
              "cityName":"唐山市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734027712053249",
              "countyCode":null,
              "regionNamePinyin":"tangshanshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"140100",
              "cityName":"太原市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130734092908314625",
              "countyCode":null,
              "regionNamePinyin":"taiyuanshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"150500",
              "cityName":"通辽市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130733979989262338",
              "countyCode":null,
              "regionNamePinyin":"tongliaoshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"211200",
              "cityName":"铁岭市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130734036452982787",
              "countyCode":null,
              "regionNamePinyin":"tielingshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"220500",
              "cityName":"通化市",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130734097979228162",
              "countyCode":null,
              "regionNamePinyin":"tonghuashi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"321200",
              "cityName":"泰州市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734104283267074",
              "countyCode":null,
              "regionNamePinyin":"taizhoushi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"331000",
              "cityName":"台州市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130734041578422274",
              "countyCode":null,
              "regionNamePinyin":"taizhoushi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"340700",
              "cityName":"铜陵市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734024885092353",
              "countyCode":null,
              "regionNamePinyin":"tonglingshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"370900",
              "cityName":"泰安市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734077288726530",
              "countyCode":null,
              "regionNamePinyin":"taianshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"429006",
              "cityName":"天门市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733964298371074",
              "countyCode":null,
              "regionNamePinyin":"tianmenshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"469022",
              "cityName":"屯昌县",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733974461169665",
              "countyCode":null,
              "regionNamePinyin":"tunchangxian",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"520600",
              "cityName":"铜仁市",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130734042878656514",
              "countyCode":null,
              "regionNamePinyin":"tongrenshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"610200",
              "cityName":"铜川市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130734091238981633",
              "countyCode":null,
              "regionNamePinyin":"tongchuanshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"620500",
              "cityName":"天水市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734081294286849",
              "countyCode":null,
              "regionNamePinyin":"tianshuishi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"650400",
              "cityName":"吐鲁番市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734069021753345",
              "countyCode":null,
              "regionNamePinyin":"tulufanshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"654200",
              "cityName":"塔城地区",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130733997110411266",
              "countyCode":null,
              "regionNamePinyin":"tachengdiqu",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"659003",
              "cityName":"图木舒克市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734022871826440",
              "countyCode":null,
              "regionNamePinyin":"tumushukeshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"659006",
              "cityName":"铁门关市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734023878459394",
              "countyCode":null,
              "regionNamePinyin":"tiemenguanshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"710100",
              "cityName":"台北市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734080061161473",
              "countyCode":null,
              "regionNamePinyin":"taibeishi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"710300",
              "cityName":"桃园市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130733967838363650",
              "countyCode":null,
              "regionNamePinyin":"taoyuanshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"710400",
              "cityName":"台中市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130733980127674370",
              "countyCode":null,
              "regionNamePinyin":"taizhongshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"710500",
              "cityName":"台南市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130733990248529921",
              "countyCode":null,
              "regionNamePinyin":"tainanshi",
              "regionNameInitial":"T"
          },
          {
              "cityCode":"719009",
              "cityName":"台东县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022871826433",
              "countyCode":null,
              "regionNamePinyin":"taidongxian",
              "regionNameInitial":"T"
          }
      ]
  ],
  [
      "W",
      [
          {
              "cityCode":"150300",
              "cityName":"乌海市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734101414363137",
              "countyCode":null,
              "regionNamePinyin":"wuhaishi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"150900",
              "cityName":"乌兰察布市",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734076261122049",
              "countyCode":null,
              "regionNamePinyin":"wulanchabushi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"320200",
              "cityName":"无锡市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130733998410645505",
              "countyCode":null,
              "regionNamePinyin":"wuxishi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"330300",
              "cityName":"温州市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130734066148655106",
              "countyCode":null,
              "regionNamePinyin":"wenzhoushi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"340200",
              "cityName":"芜湖市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734077959815170",
              "countyCode":null,
              "regionNamePinyin":"wuhushi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"370700",
              "cityName":"潍坊市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130733962075389954",
              "countyCode":null,
              "regionNamePinyin":"weifangshi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"371000",
              "cityName":"威海市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734037103099905",
              "countyCode":null,
              "regionNamePinyin":"weihaishi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"420100",
              "cityName":"武汉市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734096423141378",
              "countyCode":null,
              "regionNamePinyin":"wuhanshi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"450400",
              "cityName":"梧州市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130733973777498113",
              "countyCode":null,
              "regionNamePinyin":"wuzhoushi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"469001",
              "cityName":"五指山市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733975400693761",
              "countyCode":null,
              "regionNamePinyin":"wuzhishanshi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"469005",
              "cityName":"文昌市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733975316807682",
              "countyCode":null,
              "regionNamePinyin":"wenchangshi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"469006",
              "cityName":"万宁市",
              "provinceCode":"460000",
              "provinceName":"海南省",
              "id":"1130733975291641857",
              "countyCode":null,
              "regionNamePinyin":"wanningshi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"532600",
              "cityName":"文山壮族苗族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734042467614721",
              "countyCode":null,
              "regionNamePinyin":"wenshanzhuangzumiaozuzizhizhou",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"610500",
              "cityName":"渭南市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130734038860513281",
              "countyCode":null,
              "regionNamePinyin":"weinanshi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"620600",
              "cityName":"武威市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734072461082626",
              "countyCode":null,
              "regionNamePinyin":"wuweishi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"640300",
              "cityName":"吴忠市",
              "provinceCode":"640000",
              "provinceName":"宁夏回族自治区",
              "id":"1130734043654602753",
              "countyCode":null,
              "regionNamePinyin":"wuzhongshi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"650100",
              "cityName":"乌鲁木齐市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130733959760134146",
              "countyCode":null,
              "regionNamePinyin":"wulumuqishi",
              "regionNameInitial":"W"
          },
          {
              "cityCode":"659004",
              "cityName":"五家渠市",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734022871826438",
              "countyCode":null,
              "regionNamePinyin":"wujiaqushi",
              "regionNameInitial":"W"
          }
      ]
  ],
  [
      "X",
      [
          {
              "cityCode":"130500",
              "cityName":"邢台市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734069051113474",
              "countyCode":null,
              "regionNamePinyin":"xingtaishi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"140900",
              "cityName":"忻州市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130734097241030658",
              "countyCode":null,
              "regionNamePinyin":"xinzhoushi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"152200",
              "cityName":"兴安盟",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130733987203465218",
              "countyCode":null,
              "regionNamePinyin":"xinganmeng",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"152500",
              "cityName":"锡林郭勒盟",
              "provinceCode":"150000",
              "provinceName":"内蒙古自治区",
              "id":"1130734015217221634",
              "countyCode":null,
              "regionNamePinyin":"xilinguolemeng",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"320300",
              "cityName":"徐州市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734043134509057",
              "countyCode":null,
              "regionNamePinyin":"xuzhoushi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"341800",
              "cityName":"宣城市",
              "provinceCode":"340000",
              "provinceName":"安徽省",
              "id":"1130734071928406018",
              "countyCode":null,
              "regionNamePinyin":"xuanchengshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"350200",
              "cityName":"厦门市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130733974821879809",
              "countyCode":null,
              "regionNamePinyin":"xiamenshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"360500",
              "cityName":"新余市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130733967783837698",
              "countyCode":null,
              "regionNamePinyin":"xinyushi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"410700",
              "cityName":"新乡市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734099686309889",
              "countyCode":null,
              "regionNamePinyin":"xinxiangshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"411000",
              "cityName":"许昌市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734094678310913",
              "countyCode":null,
              "regionNamePinyin":"xuchangshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"411500",
              "cityName":"信阳市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130733991179665409",
              "countyCode":null,
              "regionNamePinyin":"xinyangshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"420600",
              "cityName":"襄阳市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733966504574977",
              "countyCode":null,
              "regionNamePinyin":"xiangyangshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"420900",
              "cityName":"孝感市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734103591206913",
              "countyCode":null,
              "regionNamePinyin":"xiaoganshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"421200",
              "cityName":"咸宁市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733980773597186",
              "countyCode":null,
              "regionNamePinyin":"xianningshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"429004",
              "cityName":"仙桃市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130733964382257153",
              "countyCode":null,
              "regionNamePinyin":"xiantaoshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"430300",
              "cityName":"湘潭市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130734100801994754",
              "countyCode":null,
              "regionNamePinyin":"xiangtanshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"433100",
              "cityName":"湘西土家族苗族自治州",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130733961546907649",
              "countyCode":null,
              "regionNamePinyin":"xiangxitujiazumiaozuzizhizhou",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"532800",
              "cityName":"西双版纳傣族自治州",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130733987820027905",
              "countyCode":null,
              "regionNamePinyin":"xishuangbannadaizuzizhizhou",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"610100",
              "cityName":"西安市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130734101707964418",
              "countyCode":null,
              "regionNamePinyin":"xianshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"610400",
              "cityName":"咸阳市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130734061987905537",
              "countyCode":null,
              "regionNamePinyin":"xianyangshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"630100",
              "cityName":"西宁市",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130734046460592129",
              "countyCode":null,
              "regionNamePinyin":"xiningshi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"710200",
              "cityName":"新北市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734101510832130",
              "countyCode":null,
              "regionNamePinyin":"xinbeishi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"710800",
              "cityName":"新竹市",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734062944206850",
              "countyCode":null,
              "regionNamePinyin":"xinzhushi",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"719002",
              "cityName":"新竹县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022590808071",
              "countyCode":null,
              "regionNamePinyin":"xinzhuxian",
              "regionNameInitial":"X"
          },
          {
              "cityCode":"810000",
              "cityName":"香港特别行政区",
              "provinceCode":"810000",
              "provinceName":"香港特别行政区",
              "id":"1130734001619288065",
              "countyCode":null,
              "regionNamePinyin":"xianggangtebiexingzhengqu",
              "regionNameInitial":"X"
          }
      ]
  ],
  [
      "Y",
      [
          {
              "cityCode":"140300",
              "cityName":"阳泉市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130733982342266882",
              "countyCode":null,
              "regionNamePinyin":"yangquanshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"140800",
              "cityName":"运城市",
              "provinceCode":"140000",
              "provinceName":"山西省",
              "id":"1130734044048867329",
              "countyCode":null,
              "regionNamePinyin":"yunchengshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"210800",
              "cityName":"营口市",
              "provinceCode":"210000",
              "provinceName":"辽宁省",
              "id":"1130733962708729857",
              "countyCode":null,
              "regionNamePinyin":"yingkoushi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"222400",
              "cityName":"延边朝鲜族自治州",
              "provinceCode":"220000",
              "provinceName":"吉林省",
              "id":"1130734058846371842",
              "countyCode":null,
              "regionNamePinyin":"yanbianchaoxianzuzizhizhou",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"230700",
              "cityName":"伊春市",
              "provinceCode":"230000",
              "provinceName":"黑龙江省",
              "id":"1130734095634612226",
              "countyCode":null,
              "regionNamePinyin":"yichunshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"320900",
              "cityName":"盐城市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734070590423042",
              "countyCode":null,
              "regionNamePinyin":"yanchengshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"321000",
              "cityName":"扬州市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130733986536570882",
              "countyCode":null,
              "regionNamePinyin":"yangzhoushi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"360600",
              "cityName":"鹰潭市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130733982497456129",
              "countyCode":null,
              "regionNamePinyin":"yingtanshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"360900",
              "cityName":"宜春市",
              "provinceCode":"360000",
              "provinceName":"江西省",
              "id":"1130734046175379458",
              "countyCode":null,
              "regionNamePinyin":"yichunshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"370600",
              "cityName":"烟台市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734013568860161",
              "countyCode":null,
              "regionNamePinyin":"yantaishi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"420500",
              "cityName":"宜昌市",
              "provinceCode":"420000",
              "provinceName":"湖北省",
              "id":"1130734024746680322",
              "countyCode":null,
              "regionNamePinyin":"yichangshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"430600",
              "cityName":"岳阳市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130733994501554178",
              "countyCode":null,
              "regionNamePinyin":"yueyangshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"430900",
              "cityName":"益阳市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130733988197515266",
              "countyCode":null,
              "regionNamePinyin":"yiyangshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"431100",
              "cityName":"永州市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130733991347437569",
              "countyCode":null,
              "regionNamePinyin":"yongzhoushi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"441700",
              "cityName":"阳江市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734091972984834",
              "countyCode":null,
              "regionNamePinyin":"yangjiangshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"445300",
              "cityName":"云浮市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734077406167041",
              "countyCode":null,
              "regionNamePinyin":"yunfushi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"450900",
              "cityName":"玉林市",
              "provinceCode":"450000",
              "provinceName":"广西壮族自治区",
              "id":"1130734045172940802",
              "countyCode":null,
              "regionNamePinyin":"yulinshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"511500",
              "cityName":"宜宾市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734075250294785",
              "countyCode":null,
              "regionNamePinyin":"yibinshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"511800",
              "cityName":"雅安市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130733994895818754",
              "countyCode":null,
              "regionNamePinyin":"yaanshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"530400",
              "cityName":"玉溪市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734105881296897",
              "countyCode":null,
              "regionNamePinyin":"yuxishi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"610600",
              "cityName":"延安市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130734014906843138",
              "countyCode":null,
              "regionNamePinyin":"yananshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"610800",
              "cityName":"榆林市",
              "provinceCode":"610000",
              "provinceName":"陕西省",
              "id":"1130733983101435906",
              "countyCode":null,
              "regionNamePinyin":"yulinshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"632700",
              "cityName":"玉树藏族自治州",
              "provinceCode":"630000",
              "provinceName":"青海省",
              "id":"1130734044136947713",
              "countyCode":null,
              "regionNamePinyin":"yushucangzuzizhizhou",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"640100",
              "cityName":"银川市",
              "provinceCode":"640000",
              "provinceName":"宁夏回族自治区",
              "id":"1130734077624270850",
              "countyCode":null,
              "regionNamePinyin":"yinchuanshi",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"654000",
              "cityName":"伊犁哈萨克自治州",
              "provinceCode":"650000",
              "provinceName":"新疆维吾尔自治区",
              "id":"1130734063925673985",
              "countyCode":null,
              "regionNamePinyin":"yilihasakezizhizhou",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"719001",
              "cityName":"宜兰县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022590808072",
              "countyCode":null,
              "regionNamePinyin":"yilanxian",
              "regionNameInitial":"Y"
          },
          {
              "cityCode":"719007",
              "cityName":"云林县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022871826436",
              "countyCode":null,
              "regionNamePinyin":"yunlinxian",
              "regionNameInitial":"Y"
          }
      ]
  ],
  [
      "Z",
      [
          {
              "cityCode":"130700",
              "cityName":"张家口市",
              "provinceCode":"130000",
              "provinceName":"河北省",
              "id":"1130734101057847298",
              "countyCode":null,
              "regionNamePinyin":"zhangjiakoushi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"321100",
              "cityName":"镇江市",
              "provinceCode":"320000",
              "provinceName":"江苏省",
              "id":"1130734093331939329",
              "countyCode":null,
              "regionNamePinyin":"zhenjiangshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"330900",
              "cityName":"舟山市",
              "provinceCode":"330000",
              "provinceName":"浙江省",
              "id":"1130734100034437122",
              "countyCode":null,
              "regionNamePinyin":"zhoushanshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"350600",
              "cityName":"漳州市",
              "provinceCode":"350000",
              "provinceName":"福建省",
              "id":"1130734100634222594",
              "countyCode":null,
              "regionNamePinyin":"zhangzhoushi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"370300",
              "cityName":"淄博市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734055398653953",
              "countyCode":null,
              "regionNamePinyin":"ziboshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"370400",
              "cityName":"枣庄市",
              "provinceCode":"370000",
              "provinceName":"山东省",
              "id":"1130734068476493826",
              "countyCode":null,
              "regionNamePinyin":"zaozhuangshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"410100",
              "cityName":"郑州市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734065456594946",
              "countyCode":null,
              "regionNamePinyin":"zhengzhoushi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"411600",
              "cityName":"周口市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130734015800229889",
              "countyCode":null,
              "regionNamePinyin":"zhoukoushi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"411700",
              "cityName":"驻马店市",
              "provinceCode":"410000",
              "provinceName":"河南省",
              "id":"1130733963925078018",
              "countyCode":null,
              "regionNamePinyin":"zhumadianshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"430200",
              "cityName":"株洲市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130734079562039298",
              "countyCode":null,
              "regionNamePinyin":"zhuzhoushi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"430800",
              "cityName":"张家界市",
              "provinceCode":"430000",
              "provinceName":"湖南省",
              "id":"1130733973274181633",
              "countyCode":null,
              "regionNamePinyin":"zhangjiajieshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"440400",
              "cityName":"珠海市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734090815356929",
              "countyCode":null,
              "regionNamePinyin":"zhuhaishi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"440800",
              "cityName":"湛江市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733997362069506",
              "countyCode":null,
              "regionNamePinyin":"zhanjiangshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"441200",
              "cityName":"肇庆市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130734072595300353",
              "countyCode":null,
              "regionNamePinyin":"zhaoqingshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"442000",
              "cityName":"中山市",
              "provinceCode":"440000",
              "provinceName":"广东省",
              "id":"1130733962012475393",
              "countyCode":null,
              "regionNamePinyin":"zhongshanshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"510300",
              "cityName":"自贡市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734062168260610",
              "countyCode":null,
              "regionNamePinyin":"zigongshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"512000",
              "cityName":"资阳市",
              "provinceCode":"510000",
              "provinceName":"四川省",
              "id":"1130734044384411649",
              "countyCode":null,
              "regionNamePinyin":"ziyangshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"520300",
              "cityName":"遵义市",
              "provinceCode":"520000",
              "provinceName":"贵州省",
              "id":"1130734090681139203",
              "countyCode":null,
              "regionNamePinyin":"zunyishi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"530600",
              "cityName":"昭通市",
              "provinceCode":"530000",
              "provinceName":"云南省",
              "id":"1130734076349202434",
              "countyCode":null,
              "regionNamePinyin":"zhaotongshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"620700",
              "cityName":"张掖市",
              "provinceCode":"620000",
              "provinceName":"甘肃省",
              "id":"1130734058254974978",
              "countyCode":null,
              "regionNamePinyin":"zhangyeshi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"640500",
              "cityName":"中卫市",
              "provinceCode":"640000",
              "provinceName":"宁夏回族自治区",
              "id":"1130733993490726914",
              "countyCode":null,
              "regionNamePinyin":"zhongweishi",
              "regionNameInitial":"Z"
          },
          {
              "cityCode":"719004",
              "cityName":"彰化县",
              "provinceCode":"710000",
              "provinceName":"台湾省",
              "id":"1130734022590808069",
              "countyCode":null,
              "regionNamePinyin":"zhanghuaxian",
              "regionNameInitial":"Z"
          }
      ]
  ]
]
const hotCityList = [
  {
      "cityCode":"110000",
      "cityName":"北京市",
      "provinceCode":"110000",
      "provinceName":"北京市",
      "id":"1130734065938939906",
      "countyCode":null,
      "regionNamePinyin":"beijingshi",
      "regionNameInitial":"B"
  },
  {
      "cityCode":"310000",
      "cityName":"上海市",
      "provinceCode":"310000",
      "provinceName":"上海市",
      "id":"1130733995780816897",
      "countyCode":null,
      "regionNamePinyin":"shanghaishi",
      "regionNameInitial":"S"
  },
  {
      "cityCode":"440100",
      "cityName":"广州市",
      "provinceCode":"440000",
      "provinceName":"广东省",
      "id":"1130734026353098753",
      "countyCode":null,
      "regionNamePinyin":"guangzhoushi",
      "regionNameInitial":"G"
  },
  {
      "cityCode":"440300",
      "cityName":"深圳市",
      "provinceCode":"440000",
      "provinceName":"广东省",
      "id":"1130733985072758785",
      "countyCode":null,
      "regionNamePinyin":"shenzhenshi",
      "regionNameInitial":"S"
  },
  {
      "cityCode":"120000",
      "cityName":"天津市",
      "provinceCode":"120000",
      "provinceName":"天津市",
      "id":"1130734042702495745",
      "countyCode":null,
      "regionNamePinyin":"tianjinshi",
      "regionNameInitial":"T"
  },
  {
      "cityCode":"610100",
      "cityName":"西安市",
      "provinceCode":"610000",
      "provinceName":"陕西省",
      "id":"1130734101707964418",
      "countyCode":null,
      "regionNamePinyin":"xianshi",
      "regionNameInitial":"X"
  },
  {
      "cityCode":"500000",
      "cityName":"重庆市",
      "provinceCode":"500000",
      "provinceName":"重庆市",
      "id":"1130734043931426818",
      "countyCode":null,
      "regionNamePinyin":"chongqingshi",
      "regionNameInitial":"C"
  },
  {
      "cityCode":"330100",
      "cityName":"杭州市",
      "provinceCode":"330000",
      "provinceName":"浙江省",
      "id":"1130734105407340545",
      "countyCode":null,
      "regionNamePinyin":"hangzhoushi",
      "regionNameInitial":"H"
  },
  {
      "cityCode":"320100",
      "cityName":"南京市",
      "provinceCode":"320000",
      "provinceName":"江苏省",
      "id":"1130734076592472066",
      "countyCode":null,
      "regionNamePinyin":"nanjingshi",
      "regionNameInitial":"N"
  },
  {
      "cityCode":"420100",
      "cityName":"武汉市",
      "provinceCode":"420000",
      "provinceName":"湖北省",
      "id":"1130734096423141378",
      "countyCode":null,
      "regionNamePinyin":"wuhanshi",
      "regionNameInitial":"W"
  },
  {
      "cityCode":"510100",
      "cityName":"成都市",
      "provinceCode":"510000",
      "provinceName":"四川省",
      "id":"1130734068984004610",
      "countyCode":null,
      "regionNamePinyin":"chengdushi",
      "regionNameInitial":"C"
  }
]
export  {openCityList,hotCityList};



// WEBPACK FOOTER //
// ./src/packages/common/js/cityData.js